import { Modal, Button, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const CompanyModal = ({ show, onHide, onSave, initial }) => {
  const [form, setForm] = useState({ companyName: '', taxId: '' });
  useEffect(() => { setForm(initial ?? { companyName: '', taxId: '' }) }, [initial]);

  const change = (f,v) => setForm({ ...form, [f]: v });

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{initial ? 'Edit company' : 'New company'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className='mb-2'>
          <Form.Label>Name</Form.Label>
          <Form.Control value={form.companyName}
            onChange={e=>change('companyName',e.target.value)} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Tax ID</Form.Label>
          <Form.Control value={form.taxId ?? ''}
            onChange={e=>change('taxId',e.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>Cancel</Button>
        <Button variant='primary'  onClick={() => onSave(form)}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};
export default CompanyModal;
